import { useQuery } from '@tanstack/react-query'

import { useQueryWithStorage } from '@hooks/useQueryWithStorage'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import {
  initialState,
  searchGeblokkeerdeWeken,
} from '../services/searchGeblokkeerdeWeken'

import { useGeblokkeerdeWekenSearchStore } from './useGeblokkeerdeWekenSearchStore'

export { useGeblokkeerdeWekenSearch, queryKey }

const queryKey = 'GeblokkeerdeWeken'

const useQueryStore = () => {
  const { query, storeQuery } = useGeblokkeerdeWekenSearchStore()

  return useQueryWithStorage({
    initialState: initialState,
    query,
    storeQuery,
    queryKey,
  })
}

const useGeblokkeerdeWekenSearch = () => {
  const { onChangeFilters, onReset, query, onChangePage, onChangeSort } =
    useQueryStore()
  const { hasPermissions } = useAuthenticatedUser()

  const { data, refetch, isFetching, isError } = useQuery({
    queryKey: [queryKey, query],
    queryFn: () => searchGeblokkeerdeWeken({ query }),
    enabled: hasPermissions,
    refetchOnMount: true,
  })

  return {
    data: data || initialState.data,
    isLoading: isFetching,
    isError,
    filters: query.filters,
    sort: query.sort,
    initialFilters: initialState.query.filters,
    onChangeFilters,
    onChangeSort,
    onReset,
    onRefresh: refetch,
    onChangePage,
  }
}
